import axios from "axios"
import { AUTH_STORAGE_KEYS } from "@/shared/config/auth"

export const authClient = axios.create({
	baseURL: "/api",
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
})

authClient.interceptors.request.use((config) => {
	const token = sessionStorage.getItem(AUTH_STORAGE_KEYS.ACCESS_TOKEN)
	if (token) {
		config.headers.Authorization = `Bearer ${token}`
	}
	return config
})
